import React from "react";
import { Button, Modal } from "react-bootstrap";

const CustomModalWrapV2 = ({
  id = "",
  buttonClasses = "",
  buttonContent = null,

  isModalOpen,
  showModal,
  closeModal,

  headerContent = null,
  footerContent = null,
  children,

  showCloseButton = false, // controls ❌ button
  closeOnBackdrop = true, // click outside
  closeOnEsc = true, // ESC key

  ...restProps
}) => {
  return (
    <>
      {buttonContent && (
        <Button id={id} onClick={showModal} className={buttonClasses}>
          {buttonContent}
        </Button>
      )}

      <Modal
        show={isModalOpen}
        onHide={closeModal}
        backdrop={closeOnBackdrop ? true : "static"}
        keyboard={closeOnEsc}
        {...restProps}
      >
        {headerContent && (
          <Modal.Header closeButton={showCloseButton}>{headerContent}</Modal.Header>
        )}

        <Modal.Body>{children}</Modal.Body>

        {footerContent && <Modal.Footer>{footerContent}</Modal.Footer>}
      </Modal>
    </>
  );
};

export default CustomModalWrapV2;
